// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1193fd80","703":"de7150a6"}[chunkId] + ".chunk.js";
};